import React, { useState, useEffect, useRef } from "react";
import { Music } from "lucide-react";
import { Button } from "@/src/components/ui/button.tsx";
import { API_ENDPOINTS } from "@/src/config/api.js";

const PromoTracks = () => {
    const [promoTracks, setPromoTracks] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const intervalRef = useRef(null);

    // Add this useEffect for fetching promo tracks
    useEffect(() => {
        fetch(API_ENDPOINTS.messageBoard.promoTracks(6))
            .then(response => response.json())
            .then(data => setPromoTracks(data))
            .catch(error => console.error("Error fetching promo tracks:", error));
    }, []);

    // Auto-advance carousel every 10 seconds
    useEffect(() => {
        if (promoTracks.length > 2) {
            intervalRef.current = setInterval(() => {
                setCurrentIndex((prevIndex) =>
                    (prevIndex + 1) % (promoTracks.length - 1)
                );
            }, 10000);
        }

        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
        };
    }, [promoTracks]);

    return (
        <div className="bg-neutral-900 rounded-lg p-4">
            <h2 className="font-bold text-lg mb-4">DC PROMO TRACKS</h2>
            <div className="relative overflow-hidden mb-6" style={{ height: '648px' }}>
                <div
                    className="absolute w-full transition-transform duration-1000 ease-in-out"
                    style={{
                        transform: `translateY(-${currentIndex * 326}px)`,
                        height: `${promoTracks.length * 320}px`
                    }}
                >
                    {promoTracks.map((track, i) => (
                        <div
                            key={track.id}
                            className="flex flex-col group cursor-pointer mb-3"
                            style={{ height: '320px' }}
                        >
                            <div className="relative">
                                <a href={`/promo/${track.slug}`}>
                                    <img
                                        src={`https://dreamchimney.com/tracks/images/promo-tracks/${track.id}.jpg`}
                                        alt={`${track.artist} - ${track.title}`}
                                        className="w-full aspect-square object-cover rounded-md group-hover:opacity-75 transition-opacity h-[200px] sm:h-[250px]"
                                    />
                                    <Button
                                        size="icon"
                                        className="absolute bottom-2 right-2 bg-white text-black hover:bg-gray-200 rounded-full w-8 h-8 opacity-0 group-hover:opacity-100 transition-opacity"
                                    >
                                        <Music className="h-4 w-4" />
                                    </Button>
                                </a>
                            </div>
                            <a href={track.sc_url} className="no-underline">
                                <h3 className="text-xs font-bold mt-2 truncate">{track.artist}</h3>
                                <p className="text-xs text-gray-400 truncate">{track.title} on {track.label}</p>
                            </a>
                        </div>
                    ))}
                </div>
            </div>
            <div className="text-center">
                <a href="/promo" variant="outline" size="sm" className="no-underline bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 rounded shadow text-xs w-full">
                    More Promo Tracks
                </a>
            </div>
        </div>
    );
};

export default PromoTracks; 